export default __webpack_public_path__ + "static/media/HPEdited.ab5e438f.png";